import substrateSuggestions from '../services/substrateSuggestions';
import { action } from 'satcheljs/lib/legacy';
import { getUserEmailAddress } from 'owa-session-store';

export default action('execute3SPrimeCall')(async function execute3SPrimeCall() {
    // Execute the 3S prime call
    substrateSuggestions(getUserEmailAddress(), '', false /*includeDirectory*/);
});
